import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';
import {CommandUtil} from '../../../../global/commandutil';
import {environment} from '../../../../../environments/environment';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {Color} from 'ng2-charts';
import {NavItemService} from '../../../../service/staff/service-navitem';

@Component({
  selector: 'egov-tonghop-vanbanden',
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VanBanDenTongHopComponent implements OnInit, AfterViewInit {

  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number = 0;
  public totalChuaXem: number =0;
  public totalPhoCap: number = 0;
  public totalChuaPhoCap: number = 0;
  public totalChoGiaoXuLy: number = 0;
  public totalDaVaoSo: number = 0;
  public ty: string = '';
  public status: number[] = [
    environment.chogiaoxuly
  ];
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;

  public language = language;

  public vanBanDenChartLabels: string[] = [language.chogiaoxuly, language.davaoso];
  public vanBanDenChartData: number[] = [this.totalChoGiaoXuLy, this.totalDaVaoSo];

  public vanBanDenXuLyChartLabels: string[] = [language.chuaxuly, language.dangxuly, language.hoanthanh, language.nhanchuaxem];
  public vanBanDenXuLyChartData: number[] = [this.totalChuaXuLy, this.totalDangXuLy, this.totalHoanThanh, this.totalChuaXem];

  public doughnutChartType = 'doughnut';

  public chartColors: Color[] = [
    {
      backgroundColor: [
        '#fad908',
        '#0872fa',
        '#0ef20e',
        '#f22a0e'
      ]
    }
  ];
  public chartColorsTow: Color[] = [
    {
      backgroundColor: [
        '#d111fb',
        '#f51754'
      ]
    }
  ];
  constructor(
    public vanBanDenService: VanBanDenService,
    public navItemService: NavItemService
  ) {
  }
  ngAfterViewInit() {
    this.loadTotal();
    setTimeout (() => {
      this.loadChart();
    }, 2000);
  }
  ngOnInit(): void {

  }
  public loadChart()
  {
    this.vanBanDenChartData = [this.totalChoGiaoXuLy, this.totalDaVaoSo];
    this.vanBanDenXuLyChartData = [this.totalChuaXuLy, this.totalDangXuLy, this.totalHoanThanh, this.totalChuaXem];
  }
  public loadTotal()
  {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {

        let nguoiGiaoXuLy : number = x >0  ? -1: this.nguoiNhapId;
        this.vanBanDenService.getCountByKeyword('', -1,-1, this.status.join(), CommandUtil.defaultValue,nguoiGiaoXuLy, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);
      }
    );


    this.vanBanDenService.getCountByKeyword('', -1,-1,'-1', CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalDaVaoSo = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1, environment.chuaxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1, '','').subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1, environment.dangxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1, '','').subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1, environment.hoanthanh.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, -1, '','').subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.vanBanDenService.getCountByXLKeyword('', -1, -1, environment.chuaxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, 0, '','').subscribe(recordCount => this.totalChuaXem = recordCount);
    this.vanBanDenService.getCountByKeyword('', -1,-1,'-1' , CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword('', -1,-1, '-1', CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, '','').subscribe(recordCount => this.totalChuaPhoCap = recordCount);
  }

}

